angular
  .module('VSPApp')
  .controller('KategorieMenuController', ['$scope', 'ShopService', function  ($scope, ShopService) {

    ShopService
      .loadCategories()
      .then(categories => $scope.categories = categories);

  }]);
